/*
  Koordynator popupów Puromedica (Pakiet LIFE, Zestaw, Dodaj produkt, kolejne promocje).
  Pilnuje trzech rzeczy:
  1. Naraz otwarty jest najwyżej jeden popup. Gdy warunki spełnia kilka, pokazuje się ten
     o najwyższym priorytecie (data-priority), pozostałe czekają na kolejne sprawdzenie koszyka.
  2. Odrzucenie popupu (krzyżyk, tło, Esc, "Nie, dziękuję") ukrywa go na data-dismiss-minutes minut.
     Czas liczymy od chwili zamknięcia i zapisujemy w localStorage, więc działa też po odświeżeniu strony.
  3. Po zamknięciu dowolnego popupu żaden inny nie pokazuje się przez data-pause-minutes minut.
  Gdy localStorage jest niedostępny (np. tryb prywatny), czas jest pamiętany tylko do przeładowania strony.
*/
(function () {
  if (window.PuroPopups) return;

  var PREFIX = 'puroPopup:';
  var BLOCKED_UNTIL_KEY = PREFIX + 'blockedUntil';
  var DEFAULT_DISMISS_MINUTES = 15;
  var DEFAULT_PAUSE_MINUTES = 3;
  var DEBOUNCE_MS = 200;

  var memory = {};
  var popups = new Set();
  var wanting = new Set();
  var timer = null;

  function read(key) {
    var stored = 0;
    try {
      stored = Number(localStorage.getItem(key)) || 0;
    } catch (e) {}
    return Math.max(stored, memory[key] || 0);
  }

  function write(key, value) {
    memory[key] = value;
    try {
      localStorage.setItem(key, String(value));
    } catch (e) {}
  }

  function minutes(popup, name, fallback) {
    var value = Number(popup.dataset[name]);
    return isFinite(value) && value >= 0 && popup.dataset[name] !== '' && popup.dataset[name] != null ? value : fallback;
  }

  function priorityOf(popup) {
    return Number(popup.dataset.priority) || 0;
  }

  function anyOpen() {
    return Array.from(popups).some(function (p) {
      return p.open;
    });
  }

  function isBlocked() {
    return Date.now() < read(BLOCKED_UNTIL_KEY);
  }

  function isDismissed(popup) {
    var key = popup.dataset.dismissKey;
    if (!key) return false;
    var until = read(PREFIX + key);
    return Date.now() < until;
  }

  // Wybiera zwycięzcę spośród popupów, które zgłosiły spełnione warunki.
  function evaluate() {
    timer = null;
    var candidates = Array.from(wanting);
    wanting.clear();

    if (anyOpen() || isBlocked()) return;

    candidates = candidates
      .filter(function (p) {
        return p.isConnected && !p.open && !isDismissed(p);
      })
      .sort(function (a, b) {
        return priorityOf(b) - priorityOf(a);
      });

    if (candidates.length) candidates[0].show();
  }

  window.PuroPopups = {
    register: function (popup) {
      popups.add(popup);
    },
    unregister: function (popup) {
      popups.delete(popup);
      wanting.delete(popup);
    },
    // Popup zgłasza, że jego warunki są spełnione i chce się pokazać.
    request: function (popup) {
      wanting.add(popup);
      if (!timer) timer = setTimeout(evaluate, DEBOUNCE_MS);
    },
    // Popup zgłasza, że jego warunki przestały być spełnione.
    release: function (popup) {
      wanting.delete(popup);
    },
    isDismissed: isDismissed,
    // Klient zamknął popup (albo skorzystał z oferty): ukryj go i wstrzymaj pozostałe.
    closed: function (popup) {
      var now = Date.now();
      var key = popup.dataset.dismissKey;
      if (key) write(PREFIX + key, now + minutes(popup, 'dismissMinutes', DEFAULT_DISMISS_MINUTES) * 60000);
      write(BLOCKED_UNTIL_KEY, now + minutes(popup, 'pauseMinutes', DEFAULT_PAUSE_MINUTES) * 60000);
    },
  };

  // Popup dołączony do DOM zgłasza się sam przez register(); tu tylko sprzątanie po usunięciu sekcji.
  window.addEventListener('pagehide', function () {
    if (timer) clearTimeout(timer);
  });
})();
